var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBoxArchiveRegular = function SvgBoxArchiveRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.688 5.625c.71 0 1.312.602 1.312 1.313v1.777c0 .465-.41.848-.875.848v6.562c0 .984-.793 1.75-1.75 1.75h-8.75c-.984 0-1.75-.766-1.75-1.75l-.027-6.563A.858.858 0 0 1 5 8.688v-1.75c0-.711.574-1.313 1.313-1.313h11.375Zm-1.313 10.938a.45.45 0 0 0 .438-.438V9.562H7.188v6.563c0 .246.19.438.437.438h8.75Zm1.313-8.313V6.937H6.313V8.25h11.375Zm-7.684 3.938c-.356 0-.629-.274-.629-.657 0-.355.273-.656.629-.656h3.965c.355 0 .656.3.656.656 0 .383-.3.656-.684.656h-3.937Z"
  })));
};

export default SvgBoxArchiveRegular;